const ScienceDayTemplate = 92391
const BIOTemplate = 67469
const YSC2023EnglishTemplate = 110540
const YSC2023FrenchTemplate = 110542
const ISEF2023Template = 108467

const DSD2023Template = 130995
const BuckeyeE2023Template = 130996
const OhioStepTemplate = 130997

const OasamTemplate = 134389

const OAS2023FairTemplates = [DSD2023Template, BuckeyeE2023Template, OhioStepTemplate]
const ProjectTemplates = [ScienceDayTemplate, BIOTemplate]

export default {
  data: function () {
    return {
      ScienceDayTemplate,
      BIOTemplate,
      ProjectTemplates,
      YSC2023EnglishTemplate,
      YSC2023FrenchTemplate,
      ISEF2023Template,
      DSD2023Template,
      BuckeyeE2023Template,
      OhioStepTemplate,
      OAS2023FairTemplates,
      OasamTemplate
    }
  }
}
